module.exports = __webpack_public_path__ + "static/media/hairdryer.6189a1ad.svg";